import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import * as api from "../../api/client";
import type { ApiCtx } from "../../api/client";
import type { HistoryEntry } from "../../parse/status";
import { texte } from "../../texte";

export function Logs({ ctx, history }: { ctx: ApiCtx; history: HistoryEntry[] }) {
  const [tail, setTail] = useState(200);
  const query = useQuery({
    queryKey: ["logs", ctx.apiUrl, ctx.token, ctx.workspace, tail],
    queryFn: () => api.logs(ctx, tail),
  });
  const lines = (query.data?.logs ?? []).flatMap((l) => l.last_lines).join("\n");
  const hist = history.map((h) => `- ${h.ts} ${h.text}`).join("\n");

  return (
    <>
      <div className="log-tools">
        <span className="label">{texte.logs.cloudLog}</span>
        <select value={tail} onChange={(e) => setTail(Number(e.target.value))}>
          <option value={200}>{texte.logs.last200}</option>
          <option value={500}>{texte.logs.last500}</option>
        </select>
        <span className="hint">{texte.logs.reloadHint}</span>
      </div>
      <div className="logbox">{lines || texte.logs.noLines}</div>
      <div className="log-tools" style={{ marginTop: 20 }}>
        <span className="label">{texte.logs.history}</span>
      </div>
      <div className="logbox">{hist || texte.logs.empty}</div>
    </>
  );
}
